import resourceScheduleApi from "@/apis/ResourceScheduleApi";

const resourceScheduleService = {
  async getResourceSchedule(pointId, resourceId, servicesIds) {
    return await resourceScheduleApi.getResourceSchedule(pointId, resourceId, servicesIds);
  },
}

export default resourceScheduleService;